import React, { useEffect, useState } from "react";
import Form, {
  SimpleItem,
  GroupItem,
  Label,
  EmptyItem,
} from "devextreme-react/form";
import "devextreme-react/text-area";
import { Button } from "devextreme-react";
import UserInfo from "../../UserInfo";
import {
  inserirOuAtualizar,
  criarContribuinteDs,
  criarLancamentoHabiteseDs,
  criarTaxasDs,
  criarAlvaraDs,
  criarImovelDs,
  criarAlvaraConstrucaoDs,
} from "../../DataSources";
import sysCodigoDescricao from "../../components/sysCodigoDescricao";
import ContribuinteBox from "../contribuintes/ContribuinteBox";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import ScrollView from "devextreme-react/scroll-view";
import notify from "devextreme/ui/notify";
import uiInfo from "../../ui-info";
import ShowError from "../../AppServices";
import AlvarasBox from "../lancamentos/AlvarasBox";
import ImovelBox from "../imovel/ImovelBox";
import react from "react";
import { abrirDetalhe } from "../../lancamentosUtils";

const _template = {
  _uiCarregando: false,
  id: undefined,
  sequencial: undefined,
  proprietarioId: undefined,
  prefeituraId: undefined,
  taxaId: undefined,
  ano: undefined,
  numero: undefined,
  data: undefined,
  vencimento: undefined,
  tipoHabitese: 0,
  alvaraNumero: undefined,
  enderecoObra: undefined,
  valorUnitario: 0,
  quantidade: 0,
  total: 0,
  especificacaoObra: undefined,
  situacaoStr: "N",
  obs: "",
  popupContribuinteVisivel: false,
  popupAlvaraConstrucaoVisivel: false,
  versao: 2,
  zonaObra: 1,
};

export default class Habitese extends React.Component {
  constructor(props) {
    super(props);

    console.log("habitese construido");

    this.habiteseDs = criarLancamentoHabiteseDs();
    this.alvaraConstrucaoDs = criarAlvaraConstrucaoDs();
    this.imovelDs = criarImovelDs();

    this.onImovelSelecionado = this.onImovelSelecionado.bind(this);
    this.onTaxaSelecionada = this.onTaxaSelecionada.bind(this);
    this.setAlvaraRef = this.setAlvaraRef.bind(this);
    this.onAlvaraRefSelecionado = this.onAlvaraRefSelecionado.bind(this);
    this.setContribuinteId = this.setContribuinteId.bind(this);
    this.pesquisarContribuinte = this.pesquisarContribuinte.bind(this);
    this.pesquisarAlvara = this.pesquisarAlvara.bind(this);
    this.setNomeContribuinteErro = this.setNomeContribuinteErro.bind(this);
    this.onContribuinteSelecionadoPesquisa =
      this.onContribuinteSelecionadoPesquisa.bind(this);
    this.confirmar = this.confirmar.bind(this);
    this.confirmarTela = this.confirmarTela.bind(this);
    this.confirmarPopup = this.confirmarPopup.bind(this);
    this.cancelar = this.cancelar.bind(this);
    this.itemLeitura = this.itemLeitura.bind(this);
    this.itemLeituraMoeda = this.itemLeituraMoeda.bind(this);
    this.pesquisarImovel = this.pesquisarImovel.bind(this);

    this.state = {};

    this.refAlvaraOptions = {
      editorType: "dxTextBox",
      mode: "text",
      onFocusOut: (e) => e.component.repaint(),
      onValueChanged: (e) => this.setAlvaraRef(e),
      buttons: [
        {
          name: "btnPesquisarImovel",
          location: "after",
          options: {
            icon: "search",
            onClick: this.pesquisarAlvara,
          },
        },
      ],
    };

    this.taxaDs = criarTaxasDs("habitese");

    this.contribuinteDs = criarContribuinteDs();
    this.contribuinteBoxRef = React.createRef();
    this.alvaraBoxRef = React.createRef();
    this.imovelBoxRef = react.createRef();
    this.renderContribuinte = sysCodigoDescricao(
      () => this.state.proprietarioId,
      this.setContribuinteId,
      () => this.state._uiNomeContribuinte,
      this.pesquisarContribuinte
    );

    this.taxasOptions = {
      searchEnabled: true,
      dataSource: this.taxaDs,
      valueExpr: "id",
      displayExpr: "descricao",
      searchMode: "contains",
      showClearButton: true,
      onValueChanged: this.onTaxaSelecionada,
    };

    this.tipoOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: 0, descricao: "TOTAL" },
        { id: 1, descricao: "PARCIAL" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.especialIpaporangaOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: 0, descricao: "Não" },
        { id: 1, descricao: "Completa 448" },
        { id: 2, descricao: "Final 336" },
        { id: 3, descricao: "Inicial 420" },
        { id: 4, descricao: "Diferença 448 para 336" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.zonaObraOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      cancelButtonText: "Cancelar",
      placeholder: "Selecione...",
      dataSource: [
        { id: 1, descricao: "URBANA" },
        { id: 2, descricao: "RURAL" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.imovelOptions = {
      editorType: "dxTextBox",
      mode: "text",
      onFocusOut: (e) => e.component.repaint(),
      onValueChanged: (e) => this.setImovelId(e),
      buttons: [
        {
          name: "btnPesquisarImovel",
          location: "after",
          options: {
            icon: "search",
            onClick: this.pesquisarImovel,
          },
        },
      ],
    };
  }

  itemLeitura(data) {
    if (this.state.previewData == undefined) {
      return <span></span>;
    }
    return <span>{this.state.previewData[data.dataField]}</span>;
  }

  itemLeituraMoeda(data) {
    let valor;
    if (this.state.previewData != undefined) {
      valor = this.state.previewData[data.dataField];
    }
    let str = "";
    if (valor !== undefined) {
      str = valor.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      });
    }

    return <span>{str}</span>;
  }

  obterParametrosTaxa(taxa) {
    if (taxa == undefined) {
      return {};
    }

    if (taxa.tipoDeCobranca === 0) {
      return {
        tipoCobranca: "Por Quantidade",
        calculoVisivel: true,
        qtdeSomenteLeitura: false,
        valorUnitarioSomenteLeitura: false,
        valorUnitario: taxa.valor,
      };
    } else if (taxa.tipoDeCobranca === 1) {
      return {
        tipoCobranca: "Por Faixa",
        calculoVisivel: false,
        qtdeSomenteLeitura: false,
        valorUnitarioSomenteLeitura: true,
        valorUnitario: 1,
      };
    } else if (taxa.tipoDeCobranca === 2) {
      return {
        tipoCobranca: "Por Valor Fixo",
        calculoVisivel: true,
        qtdeSomenteLeitura: false,
        valorUnitarioSomenteLeitura: true,
        valorUnitario: taxa.valor,
      };
    } else if (taxa.tipoDeCobranca === 3) {
      return {
        tipoCobranca: "Por Faixa MFSDI",
        calculoVisivel: false,
        qtdeSomenteLeitura: false,
        valorUnitarioSomenteLeitura: true,
        valorUnitario: 1,
      };
    }
  }

  onTaxaSelecionada(e) {
    if (e.event) {
      console.log("taxa selecionada", e);

      let calculoVisivel = true;
      let qtdeSomenteLeitura = true;
      let valorUnitarioSomenteLeitura = true;
      let tipoCobranca = "";
      let taxaId = e.value;
      console.log(this.state);
      let valorUnitario = this.state.valorUnitario;
      let tipoTaxa = undefined;

      if (taxaId !== undefined) {
        this.taxaDs
          .byKey(taxaId)
          .then((taxa) => {
            console.log("taxa selecionada", taxa);

            tipoTaxa = taxa.tipoTaxa;

            const {
              tipoCobranca,
              calculoVisivel,
              qtdeSomenteLeitura,
              valorUnitarioSomenteLeitura,
              valorUnitario: valorUnitarioTaxa,
            } = this.obterParametrosTaxa(taxa);

            valorUnitario = valorUnitarioTaxa;

            const novaQuantidade =
              tipoTaxa == 5 ? this.state.quantidadeM2 : this.state.quantidade;
            let novoTotal = novaQuantidade * valorUnitario;

            const novoEstado = {
              ...this.state,
              calculoVisivel: calculoVisivel,
              qtdeSomenteLeitura: qtdeSomenteLeitura,
              valorUnitarioSomenteLeitura: valorUnitarioSomenteLeitura,
              _tipoCobranca: tipoCobranca,
              _descricaoTaxa: taxa.descricao,
              valorUnitario: valorUnitario,
              tipoTaxa: tipoTaxa,
              taxaId: taxaId,
              quantidade: novaQuantidade,
              total: novoTotal,
            };

            this.setState(novoEstado);
          })
          .catch((error) => {
            ShowError(error);
          });
      }
    }
  }

  setAlvaraRef(e) {
    if (e.event) {
      if (e.value == undefined || e.value == "") {
        return;
      }

      const args = e.value.split("/");

      let numero, ano;

      if (args.length == 2 && !isNaN(args[0]) && !isNaN(args[1])) {
        numero = parseInt(args[0]);
        ano = parseInt(args[1]);
      }

      if (numero == undefined || ano == undefined) {
        ShowError("Número do alvará de referencia em formato inesperado.");
        return;
      }

      this.alvaraConstrucaoDs
        .load({
          filter: [
            ["numero", "=", numero],
            ["anoCopia", "=", ano],
          ],
        })
        .then((resp) => {
          console.log("resp alvara construcao encontrado", resp);

          if (resp.length > 0) {
            this.onAlvaraRefSelecionado(null, resp[0]);
          }
        })
        .catch((error) => ShowError(error));
    }
  }

  async onAlvaraRefSelecionado(e, alvaraDireto) {

    console.log("teste set ref e:", e, "alvara direto", alvaraDireto);

    console.log("on alvara selecionado e", e);
    console.log("alvara direto", alvaraDireto);

    if ((e == undefined || e.event == undefined) && alvaraDireto == undefined) {
      return;
    }

    let alvaraConstrucao;

    if (alvaraDireto != undefined) {
      alvaraConstrucao = alvaraDireto;
    }
    else {

      try {
        alvaraConstrucao = await this.alvaraConstrucaoDs.byKey(e.row.data.entidadeRef);
      }
      catch (error) {
        ShowError(error);
      }
    }

    const imovel = alvaraConstrucao == undefined || alvaraConstrucao.imovel == undefined ? undefined : alvaraConstrucao.imovel.sequencial;

    const proprietario =
      alvaraConstrucao == undefined ||
        alvaraConstrucao.proprietario == undefined
        ? undefined
        : alvaraConstrucao.proprietario;

    const novoEstado = {
      proprietarioId:
        proprietario == undefined ? null : proprietario.sequencial,
      alvaraNumero: alvaraConstrucao == undefined ? undefined : alvaraConstrucao.numeroCompleto,
      obraCep: alvaraConstrucao == undefined ? undefined : alvaraConstrucao.obraCEP,
      zonaObra: alvaraConstrucao == undefined ? undefined : alvaraConstrucao.zonaObra,
      imovelId: imovel,
      obraEndereco: alvaraConstrucao == undefined ? undefined : alvaraConstrucao.obraEndereco,
      obraNumero: alvaraConstrucao == undefined ? undefined : alvaraConstrucao.obraNumero,
      obraComplemento: alvaraConstrucao == undefined ? undefined : alvaraConstrucao.obraComplemento,
      obraBairro: alvaraConstrucao == undefined ? undefined : alvaraConstrucao.obraBairro,
      especificacaoObra: alvaraConstrucao == undefined ? undefined : alvaraConstrucao.especificacao,
      popupAlvaraConstrucaoVisivel: false,
      _uiNomeContribuinte: proprietario == null ? "" : proprietario.nome,
      quantidadeM2: alvaraConstrucao == undefined ? undefined : alvaraConstrucao.areaTotal,
    };

    console.log("novo estado", novoEstado);
    this.setState(novoEstado);

  }

  setContribuinteId(data) {
    let state = {};
    Object.assign(state, this.state);
    this.contribuinteDs
      .load({ filter: [["sequencial", "=", data.value]] })
      .then((result) => {
        if (result.length !== 0) {
          console.log(result);
          if (result[0] === undefined) {
            Object.assign(state, { _uiNomeContribuinte: "" });
          } else {
            Object.assign(state, { _uiNomeContribuinte: result[0].nome });
          }
        } else {
          Object.assign(state, { _uiNomeContribuinte: "" });
        }
        console.log(result);

        this.setState({
          ...state,
          proprietarioId: data.value,
          popupContribuinteVisivel: false,
        });
      })
      .catch((_) => this.setNomeContribuinteErro());
  }

  pesquisarContribuinte() {
    this.contribuinteBoxRef.current.limparFiltro();
    this.setState({ ...this.state, popupContribuinteVisivel: true });
  }

  pesquisarImovel() {
    this.imovelBoxRef.current.limparFiltro();
    this.setState({ ...this.state, popupImovelVisivel: true });
  }

  setImovelId(e) {
    if (e.event) {
      this.imovelDs
        .load({ filter: ["sequencial", "=", e.value] })
        .then((resp) => {
          if (resp.length > 0) {
            this.onImovelSelecionado(null, resp[0]);
          } else {
            const novoEstado = {
              popupImovelVisivel: false,
              imovelId: null,
              obraEndereco: "",
              obraNumero: "",
              obraComplemento: "",
              obraBairro: "",
            };
            this.setState(novoEstado);
          }
        })
        .catch((error) => ShowError(error));
    }
  }

  onImovelSelecionado(e, imovelDireto) {
    const imovel = imovelDireto ?? e.row.data;
    const novoEstado = {
      popupImovelVisivel: false,
      imovelId: imovel.sequencial,
      obraEndereco: imovel.logradouro.nomeCompleto,
      obraNumero: imovel.numero,
      obraComplemento: imovel.complemento,
      obraBairro: imovel.bairro.descricao,
    };

    this.setState(novoEstado);
  }

  pesquisarAlvara() {
    console.log("estado pesquisar alvara", this.state);
    this.alvaraBoxRef.current.filtrar();
    this.setState({ ...this.state, popupAlvaraConstrucaoVisivel: true });
  }

  setNomeContribuinteErro() {
    this.setState({ ...this.state, _uiNomeContribuinte: "<<ERRO>>" });
  }

  onContribuinteSelecionadoPesquisa(e) {
    let data = {};
    Object.assign(data, { value: e.row.data.sequencial.toString() });
    this.setContribuinteId(data);
  }

  cancelar() {
    notify("Operação cancelada", "warning");
    this.props.history.goBack();
  }
  confirmarTela() {
    this.confirmar(true);
  }

  confirmarPopup() {
    this.confirmar(false);
  }

  confirmar(preview) {
    let entidade = { ...this.state, prefeituraId: UserInfo.getPrefeitura() };
    entidade.preview = preview;
    inserirOuAtualizar(this.habiteseDs, entidade).then(
      function (data) {
        console.log("data preview", data);
        if (preview) {
          this.setState({
            exibirPopupPreview: true,
            previewData: {
              nome: data.lancamento.contribuinte.nome,
              fantasia: data.lancamento.contribuinte.fantasia,
              cpfCnpj: data.lancamento.contribuinte.documentoFormatado,
              enderecoL1: data.lancamento.detalheHabitese.enderecoL1,
              enderecoL2: data.lancamento.detalheHabitese.enderecoL2,
              ano: data.lancamento.ano,
              exercicio: data.lancamento.exercicio,
              m2: data.lancamento.detalheHabitese.qtdeM2,
              quantidadeBc: data.lancamento.qtdeLancamento,
              valor: data.lancamento.valorDoImposto,
              situacao: data.lancamento.situacao.descricao,
              valor: data.lancamento.valorDoImposto,
            },
          });
        } else {
          abrirDetalhe(this.props.history, data);
        }
      }.bind(this)
    );
  }

  componentDidMount() {
    console.log("props habitese", this.props);

    if (this.props.match.params.id !== undefined) {
      console.log("id request", this.props.match.params.id);
      this.habiteseDs
        .load({ filter: [["sequencial", "=", this.props.match.params.id]] })
        .then((response) => {
          console.log("response alvara api", response);

          if (response.length < 1) {
            notify("Registro não encontrado.", "error");
            this.props.history.goBack();
          } else {
            console.log("iniciando lógica com dados obtidos");

            console.log("response do servidor", response);
            const data = response[0];

            console.log("iniciando obtenção do habite-se");

            const habitese = data.detalheHabitese;
            console.log("dados habite-se", habitese);

            var paramsTaxa = this.obterParametrosTaxa(data.taxa);

            console.log("taxa", data.taxa, "params taxa", paramsTaxa);

            const {
              tipoCobranca,
              calculoVisivel,
              qtdeSomenteLeitura,
              valorUnitarioSomenteLeitura,
            } = paramsTaxa;

            console.log("antes de gerar novo estado");

            console.log("tipo cobrança", tipoCobranca,
              "calculo visivel", calculoVisivel,
              "qtde somente leitura", qtdeSomenteLeitura,
              "valor unitario somente leitura", valorUnitarioSomenteLeitura
            );


            let novoEstado = {
              id: data.id,
              _uiNumero: data.numeroCompleto,
              sequencial: data.sequencial,
              proprietarioId: habitese.proprietario.sequencial,
              prefeituraId: data.prefeituraId,
              taxaId: data.taxaId,
              ano: data.ano,
              numero: data.numeroLancamento,
              data: data.dataLancamento,
              vencimento: data.vencimentoAlvara,
              tipoHabitese: habitese.tipoDeHabitese,
              alvaraNumero: habitese.numeroAlvara,
              obraCep: habitese.obraCep,
              zonaObra: habitese.zonaObra,
              imovelId: data.imovel?.sequencial ?? undefined,
              obraEndereco: habitese.enderecoLogradouro,
              obraNumero: habitese.enderecoNumero,
              obraComplemento: habitese.enderecoComplemento,
              obraBairro: habitese.enderecoBairro,
              valorUnitario: data.valorUnitarioLancamento,
              quantidade: data.qtdeLancamento,
              total: data.valorDoImposto,
              especificacaoObra: habitese.especificacaoObra,
              situacaoStr: data.situacaoStr,
              obs: data.obsLancamento,
              popupContribuinteVisivel: false,
              popupAlvaraConstrucaoVisivel: false,
              versao: 2,
              zonaObra: habitese.zonaObra,
              _tipoCobranca: tipoCobranca,
              calculoVisivel,
              qtdeSomenteLeitura,
              valorUnitarioSomenteLeitura,
              tipoTaxa: data.taxa.tipoTaxa,
              quantidadeM2: habitese.qtdeM2,
              _uiNomeContribuinte:
                habitese.proprietario == undefined
                  ? null
                  : habitese.proprietario.nome,
            };

            console.log("antes de aplicar novo estado");
            this.setState(novoEstado);
          }
        })
        .catch((erro) => {
          ShowError(erro);
          this.props.history.goBack();
        });
    } else {
      const dataCorrente = new Date();

      this.setState({
        ..._template,
        data: dataCorrente,
        vencimento: dataCorrente,
        exercicio: dataCorrente.getFullYear(),
        ano: dataCorrente.getFullYear(),
      });
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <Form formData={this.state} colCount={2} labelLocation={"top"}>
            <GroupItem caption="HABITE-SE" colSpan={2} colCount={6}>
              <SimpleItem
                dataField={"_uiNumero"}
                colSpan={1}
                editorOptions={{ readOnly: true }}
              >
                <Label text="Número" />
              </SimpleItem>

              <SimpleItem
                dataField={"taxaId"}
                editorType={"dxSelectBox"}
                editorOptions={this.taxasOptions}
                colSpan={2}
              >
                <Label text="Taxa" />
              </SimpleItem>

              <SimpleItem
                dataField={"data"}
                editorType={"dxDateBox"}
                editorOptions={{ width: "100%" }}
                colSpan={1}
              >
                <Label text="Data" />
              </SimpleItem>

              <SimpleItem
                dataField={"vencimento"}
                editorType={"dxDateBox"}
                editorOptions={{ width: "100%" }}
                colSpan={1}
              >
                <Label text="Vencimento" />
              </SimpleItem>

              <SimpleItem
                dataField={"alvaraNumero"}
                colSpan={1}
                editorOptions={this.refAlvaraOptions}
              >
                <Label text="Ref. Alvará" />
              </SimpleItem>

              <SimpleItem
                dataField={"tipoHabitese"}
                editorType={"dxSelectBox"}
                editorOptions={this.tipoOptions}
                colSpan={1}
              >
                <Label text="Tipo" />
              </SimpleItem>

              <SimpleItem colSpan={5} component={this.renderContribuinte}>
                <Label text="Proprietário" />
              </SimpleItem>

              <SimpleItem
                dataField={"especificacaoObra"}
                editorType={"dxTextArea"}
                editorOptions={{ height: "90px" }}
                colSpan={6}
              >
                <Label text="Especificação da Obra" />
              </SimpleItem>
            </GroupItem>

            <GroupItem
              caption="ENDEREÇO DA OBRA"
              colSpan={2}
              colCount={7}
              visible={this.state.versao == 2}
            >
              <SimpleItem
                dataField={"enderecoObra"}
                editorType={"dxTextArea"}
                editorOptions={{ height: "90px" }}
                colSpan={4}
                visible={this.state.versao == 1}
              >
                <Label text="Endereço da Obra" />
              </SimpleItem>

              <SimpleItem
                colSpan={1}
                dataField={"obraCep"}
                editorOptions={{ mask: "00000-000" }}
              >
                <Label text="CEP" />
              </SimpleItem>

              <SimpleItem
                colSpan={1}
                dataField={"zonaObra"}
                editorType={"dxSelectBox"}
                editorOptions={this.zonaObraOptions}
              >
                <Label text="Zona" />
              </SimpleItem>
              <SimpleItem
                editorType={"dxTextBox"}
                colSpan={1}
                dataField={"imovelId"}
                editorOptions={this.imovelOptions}
              >
                <Label text="Imóvel" />
              </SimpleItem>

              <SimpleItem colSpan={3} dataField={"obraEndereco"}>
                <Label text="Endereço" />
              </SimpleItem>

              <SimpleItem colSpan={1} dataField={"obraNumero"}>
                <Label text="Número" />
              </SimpleItem>

              <SimpleItem colSpan={3} dataField={"obraComplemento"}>
                <Label text="Complemento" />
              </SimpleItem>
              <SimpleItem colSpan={4} dataField={"obraBairro"}>
                <Label text="Bairro" />
              </SimpleItem>
            </GroupItem>

            <GroupItem caption="VALORES" colSpan={2} colCount={5}>
              <SimpleItem
                colSpan={1}
                dataField={"_tipoCobranca"}
                editorOptions={{ readOnly: true }}
              >
                <Label text="Tipo de Cobrança" />
              </SimpleItem>

              <SimpleItem
                colSpan={1}
                dataField={"quantidadeM2"}
                editorType={"dxNumberBox"}
                cssClass="box-n2"
                visible={this.state.tipoTaxa == 4}
                editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
              >
                <Label text="Área Total (m²)" />
              </SimpleItem>

              <SimpleItem
                colSpan={1}
                dataField={"quantidade"}
                editorType={"dxNumberBox"}
                cssClass="box-n2"
                editorOptions={{
                  format: uiInfo.formatoNumerico.n2,
                  readOnly: this.state.qtdeSomenteLeitura,
                  onValueChanged: (e) => {
                    if (e.event) {
                      let value = this.state.valorUnitario * e.value;
                      this.setState({
                        ...this.state,
                        total: value !== 0 ? value : 0,
                      });
                    }
                  },
                }}
              >
                <Label
                  text={
                    this.state.tipoTaxa == 5
                      ? "Quantidade (m²)"
                      : "Quantidade (BC)"
                  }
                />
              </SimpleItem>

              <SimpleItem
                colSpan={1}
                dataField={"valorUnitario"}
                editorType={"dxNumberBox"}
                cssClass="box-n2"
                visible={this.state.calculoVisivel}
                editorOptions={{
                  format: uiInfo.formatoNumerico.n2,
                  readOnly: this.state.valorUnitarioSomenteLeitura,
                  onValueChanged: (e) => {
                    if (e.event) {
                      let value = this.state.quantidade * e.value;
                      this.setState({
                        ...this.state,
                        total: value !== 0 ? value : 0,
                      });
                    }
                  },
                }}
              >
                <Label text="Valor Unitário" />
              </SimpleItem>

              <SimpleItem
                colSpan={this.state.tipoTaxa == 4 ? 1 : 2}
                dataField={"total"}
                editorType={"dxNumberBox"}
                cssClass="box-n2 readOnlyBox"
                visible={this.state.calculoVisivel}
                editorOptions={{
                  format: uiInfo.formatoNumerico.n2,
                  readOnly: true,
                }}
              >
                <Label text="Total" />
              </SimpleItem>

              <SimpleItem
                dataField={"obs"}
                editorType={"dxTextArea"}
                editorOptions={{ height: "90px" }}
                colSpan={this.state._tipoCobranca == "Por Faixa MFSDI" ? 3 : 5}
              >
                <Label text="Observações" />
              </SimpleItem>
            </GroupItem>
          </Form>
          <div style={{ marginTop: "10px" }}>
            <div style={{ display: "inline-block" }}>
              <Button
                width={120}
                text="Pré-visualizar"
                type="default"
                onClick={this.confirmarTela}
              />
            </div>
            <div style={{ display: "inline-block", marginLeft: "10px" }}>
              <Button
                width={120}
                text="Salvar"
                type="success"
                onClick={this.confirmarPopup}
              />
            </div>
            <div style={{ display: "inline-block", marginLeft: "10px" }}>
              <Button text="Cancelar" onClick={this.cancelar} />
            </div>
          </div>
        </div>
        <Popup
          visible={this.state.popupContribuinteVisivel}
          onHiding={() =>
            this.setState({ ...this.state, popupContribuinteVisivel: false })
          }
          dragEnabled={false}
          closeOnOutsideClick={true}
          showCloseButton={true}
          showTitle={true}
          width={"90%"}
          height={"90%"}
          title="Pesquisar Contribuinte"
        >
          <ScrollView showScrollbar={"always"}>
            <ContribuinteBox
              onSelecionado={this.onContribuinteSelecionadoPesquisa}
              ref={this.contribuinteBoxRef}
            />
          </ScrollView>
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Fechar",
              type: "default",
              width: 150,
              onClick: () =>
                this.setState({
                  ...this.state,
                  popupContribuinteVisivel: false,
                }),
            }}
          ></ToolbarItem>
        </Popup>
        <Popup
          visible={this.state.popupAlvaraConstrucaoVisivel}
          onHiding={() =>
            this.setState({
              ...this.state,
              popupAlvaraConstrucaoVisivel: false,
            })
          }
          dragEnabled={false}
          closeOnOutsideClick={true}
          showCloseButton={true}
          showTitle={true}
          width={"90%"}
          height={"90%"}
          title="Pesquisar Alvará Construção"
        >
          <ScrollView showScrollbar={"always"}>
            <AlvarasBox
              onSelecionado={this.onAlvaraRefSelecionado}
              tipoPesquisa={"TLAC"}
              ref={this.alvaraBoxRef}
            />
          </ScrollView>
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Fechar",
              type: "default",
              width: 150,
              onClick: () =>
                this.setState({
                  ...this.state,
                  popupContribuinteVisivel: false,
                }),
            }}
          ></ToolbarItem>
        </Popup>
        <Popup
          visible={this.state.popupImovelVisivel}
          onHiding={() =>
            this.setState({ ...this.state, popupImovelVisivel: false })
          }
          dragEnabled={false}
          closeOnOutsideClick={true}
          showCloseButton={true}
          showTitle={true}
          width={"90%"}
          height={"90%"}
          title="Pesquisar Imóvel"
        >
          <ScrollView showScrollbar={"always"}>
            <ImovelBox
              onSelecionado={this.onImovelSelecionado}
              ref={this.imovelBoxRef}
            />
          </ScrollView>
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Fechar",
              type: "default",
              width: 150,
              onClick: () =>
                this.setState({ ...this.state, popupImovelVisivel: false }),
            }}
          ></ToolbarItem>
        </Popup>
        <Popup
          visible={this.state.exibirPopupPreview}
          onHiding={() => this.setState({ exibirPopupPreview: false })}
          dragEnabled={false}
          closeOnOutsideClick={true}
          showCloseButton={true}
          showTitle={true}
          width={600}
          height={350}
          title="Confirmação dos dados"
        >
          <ScrollView showScrollbar="always">
            <form>
              <Form formData={this.state.previewData}>
                <SimpleItem dataField={"nome"} render={this.itemLeitura}>
                  <Label text="Nome" />
                </SimpleItem>

                <SimpleItem dataField={"cpfCnpj"} render={this.itemLeitura}>
                  <Label text="CPF/CNPJ" />
                </SimpleItem>

                <SimpleItem dataField={"enderecoL1"} render={this.itemLeitura}>
                  <Label text="Endereco" />
                </SimpleItem>

                <SimpleItem dataField={"enderecoL2"} render={this.itemLeitura}>
                  <Label text=" " showColon={false} />
                </SimpleItem>

                <SimpleItem dataField={"m2"} render={this.itemLeitura}>
                  <Label text="Qtde. (m²)" />
                </SimpleItem>

                <SimpleItem
                  dataField={"quantidadeBc"}
                  render={this.itemLeitura}
                >
                  <Label text="Qtde. (BC)" />
                </SimpleItem>

                <SimpleItem dataField={"valor"} render={this.itemLeituraMoeda}>
                  <Label text="Valor" />
                </SimpleItem>
              </Form>
            </form>
          </ScrollView>
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Confirmar",
              type: "success",
              width: 150,
              onClick: this.confirmarPopup,
            }}
          ></ToolbarItem>
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Cancelar",
              type: "default",
              width: 150,
              onClick: () => this.setState({ exibirPopupPreview: false }),
            }}
          ></ToolbarItem>
        </Popup>
      </React.Fragment>
    );
  }
}
